import React, { Component } from 'react';
import style from './style';

export default class UiComponent extends Component {

  constructor(props) {
    super(props);
    this.getLabel = this.getLabel.bind(this);
    this.getFieldProp = this.getFieldProp.bind(this);
    this.getErrors = this.getErrors.bind(this);
  }

  getLabel() {
    let label = null;
    if (this.props.field) {
      if (this.props.field.label && !this.props.field.hideLabel === true) {
        if (this.props.field && this.props.field.rules && this.props.field.rules.required) {
          label = <b><label>{this.props.field.label}<b style={{ color: 'red' }}>*</b></label></b>;
        } else {
          label = <b><label>{this.props.field.label}</label></b>;
        }
      }
    } else {
      label = <b><label></label></b>;
    }
    return label;
  }

  getFieldProp(prop) {
    let propItem = null;

    if (prop && this.props.field && this.props.field[prop] !== undefined) {
      propItem = this.props.field[prop];
    }

    return propItem;
  }

  getErrors() {
    let errors = [];
    if (this.props.field && this.props.field.errors) {
      if (this.props.field.errors.length === 0) {
        return null;
      }

      for (let i = 0; i < this.props.field.errors.length; i++) {
        errors.push(
          <span key={i}>{this.props.field.errors[i]}</span>
        );
      }

      return (
        <div className="field-errors" style={style.errorsContainer}>
          {errors}
        </div>
      );
    }

    return errors;
  }
}




// WEBPACK FOOTER //
// ./src/common/UiComponent/index.js